<template>
    <div class="border border-tc-gray-7 rounded-lg overflow-hidden">
        <input type="tel"
               class="text-tc-blue-1 p-4 text-18 w-full placeholder-tc-gray-1"
               v-model="content"
               :placeholder="placeholderText"
               :maxlength="maxLength"
               @input="onChange()">
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import RegxHelper from "@/helper/RegxHelper.js";

export default {
    name: 'InputUsername',
    props: {
        // v-model
        inputValue: String,
        delimeter: { type: String, default: null },
        maxLength: { type: Number, default: 12 },
        placeholderText: String,
    },
    data: function() {
        return {
            content: '',
        };
    },
    created: function() {
        this.onChange();
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            //Set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            //Required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            //Too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength))
            {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
        },
        onChange: function() {
            let input = Util.isEmptyStr(this.content) ? '' : this.content;
            input = RegxHelper.removeEmoji(input);
            input = input.replace(/^[^0].*/, '');
            input = RegxHelper.removeNotNumber(input);
            if (!Util.isEmptyStr(this.delimeter)) {
                let n1, n2, n3;
                if (input.length <= 3) {
                    // do nothing
                } else if (input.length <= 6) {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    input = n1 + this.delimeter + n2;
                } else {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    n3 = input.substr(6);
                    input = n1 + this.delimeter + n2 + this.delimeter + n3;
                }
            }

            this.content = input;
            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
